module.exports = __webpack_public_path__ + "static/media/signup-intro-img-en.7f91e4ad.png";